import {
  FileModel,
  PageRequest,
  PaginationResponseType,
  ResponseType,
  StorageFileCriteria,
} from '@/types';
import { axios, get, post, put } from './baseAxios';
import { API_STORAGE } from './urls';

const url = API_STORAGE;
export const filterStorages = (
  request: PageRequest & StorageFileCriteria
): Promise<PaginationResponseType<FileModel[]>> => get(`${url}`, { params: { ...request } });

export const updateStorage = (request: FileModel): Promise<ResponseType<FileModel>> =>
  put(`${url}/${request.id}`, request);

export const deleteById = (id: number): Promise<ResponseType<boolean>> =>
  axios.delete(`${url}/${id}`);

export const createStorage = (request: FileModel): Promise<ResponseType<FileModel>> =>
  post(`${url}`, request);
